import ApiClient from "./apiClient";
import {
  StaffCluster,
  StaffClusterDetail,
  NodePoolCreate,
  NodePoolScale,
  NodePoolDetail,
  InstallAddons,
  ClusterPaginatedResponse,
} from "../pages/openstack/clusters/types";

interface ClusterListParams {
  page?: number | null;
  page_size?: number | null;
  ordering?: string | null;
  search?: string | null;
  status?: string | null;
  project_id?: string | null;
}

const normalizeListResponse = (res: { data: ClusterPaginatedResponse<StaffCluster> }) => ({
  ...res,
  data: {
    ...res.data,
    objects: res.data.results,
  },
});

const kubernetesService = {
  getList: (params: ClusterListParams) =>
    ApiClient.get('clusters', {
      params: {
        page: params.page,
        size: params.page_size,
        order_by: params.ordering,
        search: params.search,
        status: params.status,
        project_id: params.project_id,
      },
    }).then(normalizeListResponse),

  getClusterById: (id: string) =>
    ApiClient.get<StaffClusterDetail>(`clusters/${id}`),

  deleteCluster: (id: string) =>
    ApiClient.delete(`clusters/${id}`),

  createCluster: (data: Record<string, unknown>) =>
    ApiClient.post('clusters', data),

  editRestriction: (clusterId: string, data: Record<string, unknown>) =>
    ApiClient.patch(`clusters/${clusterId}`, data),

  upgradeCluster: (id: string, data: Record<string, unknown>) =>
    ApiClient.patch(`clusters/${id}`, data),

  installAddon: (id: string, data: InstallAddons) =>
    ApiClient.post(`clusters/${id}/install_addons`, data),

  // Node Pools
  getNodePool: (id: string) =>
    ApiClient.get<NodePoolDetail>(`cluster/node-pools/${id}`),

  createNodePool: (data: NodePoolCreate) =>
    ApiClient.post('cluster/node-pools', data),

  editNodePool: (id: string, data: NodePoolScale) =>
    ApiClient.patch(`cluster/node-pools/${id}`, data),

  deleteNodePool: (id: string) =>
    ApiClient.delete(`cluster/node-pools/${id}`),
};

export default kubernetesService;
